(function () {
  'use strict';

  const root = document.querySelector('.es');
  if (!root) return;

  const isFr = root.dataset.locale === 'fr';
  const localePrefix = root.dataset.localePrefix || '';
  const t = (fr, en) => isFr ? fr : en;
  // === GA4 tracking ===
  const entryPath = (() => {
    try {
      const url = new URL(window.location.href);
      const src = url.searchParams.get('cfg_from') || url.searchParams.get('source');
      if (src) return src;
      const ref = document.referrer || '';
      if (!ref) return 'direct';
      if (ref.includes('/collections/')) return 'collection';
      if (ref.includes('/products/')) return 'pdp';
      if (ref.includes('/pages/notre-gamme')) return 'notre_gamme';
      if (ref.includes('/search')) return 'search';
      const u = new URL(ref);
      if (u.host === window.location.host && (u.pathname === '/' || u.pathname.match(/^\/(en|fr|de|es|it|pt)([-/]|$)/))) return 'homepage';
      return 'other';
    } catch (e) { return 'direct'; }
  })();

  function trackEvent(name, params) {
    const payload = Object.assign({ entry_path: entryPath }, params || {});
    const send = (tries) => {
      if (typeof window.gtag === 'function') { try { window.gtag('event', name, payload); } catch (e) {} return; }
      if (tries > 0) setTimeout(() => send(tries - 1), 250);
    };
    send(40);
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
  }
  trackEvent('configurator_start', {});

  // Quicksearch form
  const qsForm = document.querySelector('[data-quicksearch-form]');
  if (qsForm) {
    qsForm.addEventListener('submit', () => {
      const q = qsForm.querySelector('input[name="q"]').value.trim();
      trackEvent('configurator_quicksearch', { query: q });
    });
  }

  const qsToggle = document.querySelector('.es-quicksearch-toggle');
  if (qsToggle) {
    qsToggle.addEventListener('toggle', () => {
      if (qsToggle.open) {
        const input = qsToggle.querySelector('.es-quicksearch-toggle__input');
        if (input) setTimeout(() => input.focus(), 50);
      }
    });
  }

  // === Asset maps ===
  let DRAWINGS = {};
  try {
    const el = document.getElementById('es-drawings-map');
    if (el) DRAWINGS = JSON.parse(el.textContent.trim());
  } catch (e) {
    console.warn('[es] drawings map parse failed', e);
  }

  let BADGES = {};
  try {
    const el = document.getElementById('es-badges-map');
    if (el) BADGES = JSON.parse(el.textContent.trim());
  } catch (e) {
    console.warn('[es] badges map parse failed', e);
  }

  function resolveDrawingUrl(file) {
    if (!file) return '';
    if (DRAWINGS[file]) return DRAWINGS[file];
    if (root.dataset.classicImageTypeG) {
      const base = root.dataset.classicImageTypeG.split('porsche-911-type-g-undercarriage-exhaust.webp')[0];
      return base + file;
    }
    return file;
  }

  function resolveBadgeUrl(file) {
    if (!file) return '';
    if (BADGES[file]) return BADGES[file];
    if (root.dataset.classicBadgeSc) {
      const base = root.dataset.classicBadgeSc.split('scart-badge-911-sc.svg')[0];
      return base + file;
    }
    return file;
  }

  // === Catalog tree (Liquid-rendered) ===
  let TREE = { brands: [] };
  try {
    TREE = JSON.parse(document.getElementById('es-catalog').textContent.trim());
  } catch (e) {
    console.error('[es] catalog parse failed', e);
  }

  // === Classic Catalog base ===
  const CLASSIC = typeof window.ScartClassicCatalog === 'function'
    ? window.ScartClassicCatalog({
        t,
        images: {
          typeG: resolveDrawingUrl('porsche-911-type-g-undercarriage-exhaust.webp') || root.dataset.classicImageTypeG,
          turbo930: resolveDrawingUrl('porsche-911-930-turbo-undercarriage-exhaust.webp') || root.dataset['classicImage-930'],
          carrera964: resolveDrawingUrl('porsche-911-964-carrera-undercarriage-exhaust.webp') || root.dataset['classicImage-964Carrera'],
          turbo964: resolveDrawingUrl('porsche-911-964-turbo-undercarriage-exhaust.webp') || root.dataset['classicImage-964Turbo'],
          carrera993: resolveDrawingUrl('porsche-911-993-carrera-undercarriage-exhaust.webp') || root.dataset['classicImage-993Carrera'],
          turbo993: resolveDrawingUrl('porsche-911-993-turbo-undercarriage-exhaust.webp') || root.dataset['classicImage-993Turbo']
        },
        badges: {
          sc: resolveBadgeUrl('scart-badge-911-sc.svg'),
          carrera: resolveBadgeUrl('scart-porsche-carrera-wordmark.svg'),
          turbo: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg')
        }
      })
    : { families: {}, cars: {} };

  // === Scart Configurator Data (full 65 vehicles catalog) ===
  const CONFIG_DATA = window.SCART_CONFIGURATOR_DATA || { vehicles: [] };
  const REVIEW_STATE = window.ScartConfiguratorReviewState || { families: {}, cars: {} };
  if (!REVIEW_STATE.families) REVIEW_STATE.families = {};
  if (!REVIEW_STATE.cars) REVIEW_STATE.cars = {};

  // Canonical classic IDs mapping
  const CANONICAL_ALIASES = {
    'porsche-911-type-g-2-7': 'type-g-27-30',
    'porsche-911-sc-3-0': 'type-g-27-30',
    'porsche-911-carrera-3-2': 'type-g-32',
    'porsche-911-930-turbo': '930',
    'porsche-911-964-carrera': '964-carrera',
    'porsche-911-964-turbo': '964-turbo',
    'porsche-911-993-carrera': '993-carrera',
    'porsche-911-993-turbo': '993-turbo'
  };

  const FAMILY_BY_CAR = {};
  (CONFIG_DATA.vehicles || []).forEach((vehicle) => {
    if (vehicle.visualFamilyId) FAMILY_BY_CAR[vehicle.id] = vehicle.visualFamilyId;
  });
  Object.entries(CANONICAL_ALIASES).forEach(([fullId, canonicalId]) => {
    if (FAMILY_BY_CAR[fullId]) FAMILY_BY_CAR[canonicalId] = FAMILY_BY_CAR[fullId];
  });

  function reviewForCar(carId) {
    const familyId = FAMILY_BY_CAR[carId];
    const canonicalId = CANONICAL_ALIASES[carId] || carId;
    return (familyId && REVIEW_STATE.families && REVIEW_STATE.families[familyId])
      || (REVIEW_STATE.cars && REVIEW_STATE.cars[carId])
      || (REVIEW_STATE.cars && REVIEW_STATE.cars[canonicalId])
      || { status: 'pending', reason: '', reviewer: '', published: false, locked: false };
  }

  function reviewLabel(status) {
    if (status === 'validated') return t('Validé', 'Validated');
    if (status === 'rejected') return t('À revoir', 'Needs changes');
    return t('À valider', 'Pending review');
  }

  function reviewStatusForDestination(destination) {
    if (!destination) return null;
    if (destination.car) return reviewForCar(destination.car).status;
    const family = destination.family && ALL_FAMILIES[destination.family];
    if (!family) return null;
    const statuses = family.versions.map((version) => reviewForCar(version.id).status);
    if (statuses.indexOf('rejected') !== -1) return 'rejected';
    if (statuses.length && statuses.every((status) => status === 'validated')) return 'validated';
    return 'pending';
  }

  function reviewPillHtml(status) {
    return status
      ? `<span class="es__review-pill es__review-pill--${status}">${reviewLabel(status)}</span>`
      : '';
  }

  Object.entries(CANONICAL_ALIASES).forEach(([fullId, canonId]) => {
    if (CLASSIC.cars[canonId]) {
      CLASSIC.cars[fullId] = CLASSIC.cars[canonId];
    }
  });

  // Populate CLASSIC.cars with all remaining vehicles from CONFIG_DATA
  (CONFIG_DATA.vehicles || []).forEach((v) => {
    if (!CLASSIC.cars[v.id]) {
      CLASSIC.cars[v.id] = {
        id: v.id,
        name: v.displayName,
        description: v.description,
        architecture: v.architecture,
        caption: v.caption || t('Les zones rouges correspondent uniquement aux pièces proposées par Scart.', 'Red areas only show parts offered by Scart.'),
        image: resolveDrawingUrl(v.drawingAsset),
        alt: t('Vue de dessous technique ' + v.displayName, 'Technical underside view of ' + v.displayName),
        zones: v.zones || [],
        accessories: v.accessories || [],
        isProductionReference: Boolean(v.isProductionReference),
        zoneCalibration: v.zoneCalibration || 'test-heuristic'
      };
    } else {
      CLASSIC.cars[v.id].accessories = v.accessories || [];
      CLASSIC.cars[v.id].isProductionReference = Boolean(v.isProductionReference);
      CLASSIC.cars[v.id].zoneCalibration = v.zoneCalibration || 'production';
    }
  });

  // Production overrides are the baseline. Brieuc's saved draft overrides are
  // loaded only by the test journey and win without touching the public route.
  const ZONE_OVERRIDES = Object.assign(
    {},
    window.ScartClassicZoneOverrides || {},
    window.ScartConfiguratorDraftZones || {}
  );
  Object.entries(ZONE_OVERRIDES).forEach(([carId, zoneRects]) => {
    if (!CLASSIC.cars[carId] || !zoneRects || typeof zoneRects !== 'object') return;
    CLASSIC.cars[carId].zones.forEach((zone) => {
      const rects = zoneRects[zone.id];
      if (Array.isArray(rects)) zone.rects = rects.map((rect) => rect.map(Number));
    });
  });

  // Map accessories to canonical classic IDs
  Object.entries(CANONICAL_ALIASES).forEach(([fullId, canonId]) => {
    if (CLASSIC.cars[fullId] && CLASSIC.cars[canonId]) {
      CLASSIC.cars[canonId].accessories = CLASSIC.cars[fullId].accessories || [];
    }
  });

  // Multi-version families definitions for screen: classic-version
  const ALL_FAMILIES = {
    'classic-type-g': {
      label: 'Type G',
      versions: [
        { id: 'type-g-27-30', label: '2,7 L / 3,0 L', meta: '1974–1983 · ' + t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-badge-911-sc.svg') },
        { id: 'type-g-32', label: '3,2 L Carrera', meta: '1984–1989 · ' + t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-porsche-carrera-wordmark.svg') },
        { id: '930', label: '930 Turbo', meta: '1975–1989 · ' + t('Simple turbo', 'Single turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'classic-964': {
      label: '964',
      versions: [
        { id: '964-carrera', label: '964 Carrera', meta: t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-porsche-carrera-wordmark.svg') },
        { id: '964-turbo', label: '964 Turbo', meta: t('Simple turbo', 'Single turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'classic-993': {
      label: '993',
      versions: [
        { id: '993-carrera', label: '993 Carrera', meta: t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-porsche-carrera-wordmark.svg') },
        { id: '993-turbo', label: '993 Turbo', meta: t('Deux turbos', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-type-f': {
      label: 'Type F',
      versions: [
        { id: 'porsche-911-type-f', label: '911 Type F (1963–1973)', meta: t('Atmosphérique 2.0 / 2.2 / 2.4', 'Naturally aspirated 2.0 / 2.2 / 2.4'), badge: resolveBadgeUrl('scart-logo-porsche-911.svg') },
        { id: 'porsche-911-type-f-1973-1976', label: '911 (1973–1976)', meta: t('Période intermédiaire', 'Intermediate period'), badge: resolveBadgeUrl('scart-logo-porsche-911.svg') },
        { id: 'porsche-911-carrera-rs-2-7', label: '911 Carrera RS 2.7', meta: t('1973 · Atmosphérique 2.7L', '1973 · Naturally aspirated 2.7L'), badge: resolveBadgeUrl('scart-logo-porsche-carrera-rs.svg') }
      ]
    },
    'family-996': {
      label: '996',
      versions: [
        { id: 'porsche-911-996-carrera', label: '911 Carrera 3.4 / 3.6', meta: t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-porsche-carrera-wordmark.svg') },
        { id: 'porsche-911-996-gt3', label: '911 GT3 (996)', meta: t('Atmosphérique sport', 'High-rev NA'), badge: resolveBadgeUrl('scart-porsche-gt3-wordmark.svg') },
        { id: 'porsche-911-996-turbo', label: '911 Turbo (996)', meta: t('Deux turbos', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-997-1': {
      label: '997.1',
      versions: [
        { id: 'porsche-911-997-1-carrera', label: '911 Carrera (997.1)', meta: t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-porsche-carrera-wordmark.svg') },
        { id: 'porsche-911-997-1-gt3', label: '911 GT3 (997.1)', meta: t('Atmosphérique sport', 'High-rev NA'), badge: resolveBadgeUrl('scart-porsche-gt3-wordmark.svg') },
        { id: 'porsche-911-997-1-turbo', label: '911 Turbo (997.1)', meta: t('Deux turbos', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-997-2': {
      label: '997.2',
      versions: [
        { id: 'porsche-911-997-2-carrera', pseCar: 'porsche-911-997-2-carrera-pse', label: '911 Carrera (997.2)', meta: t('Avec ou sans PSE d’origine', 'With or without factory PSE'), badges: [resolveBadgeUrl('scart-porsche-carrera-wordmark.svg'), resolveBadgeUrl('scart-logo-porsche-carrera-pse.svg')] },
        { id: 'porsche-911-997-2-turbo', label: '911 Turbo / Turbo S (997.2)', meta: t('Deux turbos', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') },
        { id: 'porsche-911-997-2-gt3', label: '911 GT3 / GT3 RS (997.2)', meta: t('Atmosphérique sport', 'High-rev NA'), badges: [resolveBadgeUrl('scart-porsche-gt3-wordmark.svg'), resolveBadgeUrl('scart-porsche-gt3-rs-wordmark.png')] },
        { id: 'porsche-911-997-2-gt2-rs', label: '911 GT2 RS (997.2)', meta: t('Deux turbos · 620 ch', 'Twin turbo · 620 hp'), badge: resolveBadgeUrl('scart-porsche-gt2-rs-wordmark.png') }
      ]
    },
    'family-991-1': {
      label: '991.1',
      versions: [
        { id: 'porsche-911-991-1-carrera', pseCar: 'porsche-911-991-1-carrera-pse', label: '911 Carrera (991.1)', meta: t('Avec ou sans PSE d’origine', 'With or without factory PSE'), badges: [resolveBadgeUrl('scart-porsche-carrera-wordmark.svg'), resolveBadgeUrl('scart-logo-porsche-carrera-pse.svg')] },
        { id: 'porsche-911-991-1-gt3', label: '911 GT3 (991.1)', meta: t('Atmosphérique sport', 'High-rev NA'), badge: resolveBadgeUrl('scart-porsche-gt3-wordmark.svg') },
        { id: 'porsche-911-991-1-turbo', label: '911 Turbo (991.1)', meta: t('Deux turbos', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-991-2': {
      label: '991.2',
      versions: [
        { id: 'porsche-911-991-2-carrera', pseCar: 'porsche-911-991-2-carrera-pse', label: '911 Carrera (991.2)', meta: t('Avec ou sans PSE d’origine', 'With or without factory PSE'), badges: [resolveBadgeUrl('scart-porsche-carrera-wordmark.svg'), resolveBadgeUrl('scart-logo-porsche-carrera-pse.svg')] },
        { id: 'porsche-911-991-2-gt3', label: '911 GT3 (991.2)', meta: t('Atmosphérique 4.0L', '4.0L NA'), badge: resolveBadgeUrl('scart-porsche-gt3-wordmark.svg') },
        { id: 'porsche-911-991-2-turbo', label: '911 Turbo (991.2)', meta: t('Bi-turbo 3.8L', 'Bi-turbo 3.8L'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-718': {
      label: '718',
      versions: [
        { id: 'porsche-718-4-0', label: '718 Spyder / Cayman GT4 4.0', meta: t('Atmosphérique 4.0L', '4.0L NA'), badges: [resolveBadgeUrl('scart-logo-porsche-718-spyder.svg'), resolveBadgeUrl('scart-logo-porsche-718-gt4.svg')] },
        { id: 'porsche-718-gt4-rs', label: '718 Cayman GT4 RS', meta: t('Atmosphérique 500 ch', '500 hp NA'), badge: resolveBadgeUrl('scart-logo-porsche-718-gt4-rs.svg') }
      ]
    },
    'family-928': {
      label: '928',
      versions: [
        { id: 'porsche-928-s', label: '928 S', meta: t('V8 4.7L', '4.7L V8'), badge: resolveBadgeUrl('scart-logo-porsche-928-s.svg') },
        { id: 'porsche-928-s4-gt-gts', label: '928 S4 / GT / GTS', meta: t('V8 5.0L / 5.4L', '5.0L / 5.4L V8'), badges: [resolveBadgeUrl('scart-logo-porsche-928-s4.svg'), resolveBadgeUrl('scart-logo-porsche-928-gt.svg'), resolveBadgeUrl('scart-logo-porsche-928-gts.svg')] }
      ]
    },
    'family-912': {
      label: '912',
      versions: [
        { id: 'porsche-912', label: '912 Classic', meta: '1965–1969 · Flat-4 1.6L', badge: resolveBadgeUrl('scart-logo-porsche-912.jpg') },
        { id: 'porsche-912e', label: '912E', meta: '1976 · Flat-4 2.0L', badge: resolveBadgeUrl('scart-logo-porsche-912e.svg') }
      ]
    },
    'family-914': {
      label: '914',
      versions: [
        { id: 'porsche-914-4-1-7', label: '914/4 1.7 L', meta: t('Échangeurs 1.7L', '1.7L heat exchangers'), badge: resolveBadgeUrl('scart-logo-porsche-914.svg') },
        { id: 'porsche-914-4-2-0', label: '914/4 2.0 L', meta: t('Échangeurs 2.0L', '2.0L heat exchangers'), badge: resolveBadgeUrl('scart-logo-porsche-914.svg') }
      ]
    },
    'family-cayenne-955': {
      label: 'Cayenne (955)',
      versions: [
        { id: 'porsche-cayenne-955-s', label: 'Cayenne S (955)', meta: 'V8 4.5L · ' + t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-logo-porsche-cayenne.svg') },
        { id: 'porsche-cayenne-955-turbo', label: 'Cayenne Turbo (955)', meta: 'V8 4.5L · ' + t('Bi-turbo', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-cayenne-957': {
      label: 'Cayenne (957)',
      versions: [
        { id: 'porsche-cayenne-957-s', label: 'Cayenne S (957)', meta: 'V8 4.8L · ' + t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-logo-porsche-cayenne.svg') },
        { id: 'porsche-cayenne-957-turbo', label: 'Cayenne Turbo (957)', meta: 'V8 4.8L · ' + t('Bi-turbo', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-cayenne-958': {
      label: 'Cayenne (958)',
      versions: [
        { id: 'porsche-cayenne-958', label: 'Cayenne (958) V8 Atmo', meta: 'V8 4.8L · ' + t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-logo-porsche-cayenne.svg') },
        { id: 'porsche-cayenne-958-turbo', label: 'Cayenne Turbo (958)', meta: 'V8 4.8L · ' + t('Bi-turbo', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-panamera-970': {
      label: 'Panamera (970)',
      versions: [
        { id: 'porsche-panamera-970', label: 'Panamera (970) V6 / V8 / 4S', meta: t('Atmosphérique', 'Naturally aspirated'), badge: resolveBadgeUrl('scart-logo-porsche-panamera.svg') },
        { id: 'porsche-panamera-970-turbo', label: 'Panamera Turbo (970)', meta: 'V8 4.8L · ' + t('Bi-turbo', 'Twin turbo'), badge: resolveBadgeUrl('scart-porsche-turbo-wordmark.svg') }
      ]
    },
    'family-audi-r8': {
      label: 'Audi R8',
      versions: [
        { id: 'audi-r8-v8', label: 'Audi R8 V8 4.2', meta: 'V8 4.2L FSI · 420–430 ch', badge: resolveBadgeUrl('scart-logo-audi-v8.svg') },
        { id: 'audi-r8-v10', label: 'Audi R8 V10 5.2', meta: 'V10 5.2L FSI · 525–560 ch', badge: resolveBadgeUrl('scart-logo-audi-v10.svg') }
      ]
    }
  };

  // Resolve target family or single car for any node
  function resolveDestination(brandHandle, modelHandle, genHandle) {
    if (genHandle) {
      if (genHandle === '911-type-f-1') return { family: 'family-type-f' };
      if (genHandle === '911-2-7l-3-0l-type-g' || genHandle === '911-type-g') return { family: 'classic-type-g' };
      if (genHandle === '964') return { family: 'classic-964' };
      if (genHandle === '993') return { family: 'classic-993' };
      if (genHandle === '996') return { family: 'family-996' };
      if (genHandle === '997') return { family: 'family-997-1' };
      if (genHandle === '997-2') return { family: 'family-997-2' };
      if (genHandle === '991') return { family: 'family-991-1' };
      if (genHandle === '991-2') return { family: 'family-991-2' };
      if (genHandle === '992') return { car: 'porsche-911-992-carrera' };
      if (genHandle === '986') return { car: 'porsche-boxster-986' };
      if (genHandle === '987') return { car: 'porsche-boxster-987-1' };
      if (genHandle === '987-2') return { car: 'porsche-boxster-987-2' };
      if (genHandle === '981') return { car: 'porsche-boxster-981' };
      if (genHandle === '981-1' || genHandle === '718') return { family: 'family-718' };
      if (genHandle === 'porsche-912-classic') return { car: 'porsche-912' };
      if (genHandle === 'porsche-912e') return { car: 'porsche-912e' };
      if (genHandle === '955') return { family: 'family-cayenne-955' };
      if (genHandle === '957') return { family: 'family-cayenne-957' };
      if (genHandle === '958') return { family: 'family-cayenne-958' };
      if (genHandle === '9ya') return { car: 'porsche-cayenne-9ya-v6' };
      if (genHandle === 'cayenne') return { family: 'family-cayenne-955' };
    }
    if (modelHandle) {
      if (modelHandle === '356') return { car: 'porsche-356' };
      if (modelHandle === '930') return { car: '930' };
      if (modelHandle === '928') return { family: 'family-928' };
      if (modelHandle === '944') return { car: 'porsche-944-turbo' };
      if (modelHandle === '968') return { car: 'porsche-968' };
      if (modelHandle === '914') return { family: 'family-914' };
      if (modelHandle === 'porsche-912') return { family: 'family-912' };
      if (modelHandle === 'panamera') return { family: 'family-panamera-970' };
      if (modelHandle === '360') return { car: 'ferrari-360' };
      if (modelHandle === 'f430') return { car: 'ferrari-f430' };
      if (modelHandle === '456') return { car: 'ferrari-456' };
      if (modelHandle === 'testarossa') return { car: 'ferrari-testarossa' };
      if (modelHandle === 'ferrari-512') return { car: 'ferrari-512-bb' };
      if (modelHandle === 'audi' || modelHandle === 'r8') return { family: 'family-audi-r8' };
      if (modelHandle === 'a110' || modelHandle === 'a110r') return { car: 'alpine-a110' };
      if (modelHandle === 'aston-martin' || modelHandle === 'db7') return { car: 'aston-martin-db7-v12' };
      if (modelHandle === 'amg-gt') return { car: 'mercedes-amg-gt-black-series' };
    }
    return null;
  }

  // Helpers
  function findBrand(handle) { return TREE.brands.find(b => b.handle === handle); }
  function findModel(brandHandle, modelHandle) {
    const b = findBrand(brandHandle);
    return b ? b.models.find(m => m.handle === modelHandle) : null;
  }
  function findGen(brandHandle, modelHandle, genHandle) {
    const m = findModel(brandHandle, modelHandle);
    return m ? (m.generations || []).find(g => g.handle === genHandle) : null;
  }

  function findBrandHandleByName(name) {
    const normalized = String(name || '').trim().toLowerCase();
    const match = TREE.brands.find((brand) => String(brand.label || '').trim().toLowerCase() === normalized);
    return match ? match.handle : normalized.replace(/\s+/g, '-');
  }

  // === State ===
  const state = {
    brand: null,
    model: null,
    generation: null,
    classicFamily: null,
    classicCar: null,
    pendingPseChoice: null,
    classicZone: null,
    classicFilter: null,
    classicZoneProducts: [],
    classicZoneFailures: [],
    zoneEditing: false,
    zoneDirty: false,
    zoneDrag: null,
    zoneSelection: null
  };
  let activeScreen = 'brand';

  function $screen(name) { return root.querySelector(`[data-screen="${name}"]`); }

  function transitionTo(name) {
    root.classList.toggle('is-in-journey', name !== 'brand');
    if (activeScreen === name) return;
    const cur = root.querySelector('.es__screen.is-active');
    if (cur) { cur.classList.remove('is-active'); cur.hidden = true; }
    const next = $screen(name);
    if (next) {
      next.hidden = false;
      void next.offsetWidth;
      next.classList.add('is-active');
      activeScreen = name;
      updateEchoes();
      updateBreadcrumb();
      const hero = root.querySelector('.es__hero');
      if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function setClassicQuery(carId) {
    try {
      const url = new URL(window.location.href);
      if (carId) url.searchParams.set('car', carId);
      else url.searchParams.delete('car');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  // === Render Card Grids ===
  function imgHtml(image, alt) {
    if (image) return `<span class="es__card-image"><img src="${image}" alt="${alt || ''}" loading="lazy"></span>`;
    return `<span class="es__card-image es__card-image--empty"></span>`;
  }

  function renderBrandGrid() {
    const grid = root.querySelector('[data-grid="brand"]');
    if (!grid) return;
    grid.innerHTML = '';
    for (const b of TREE.brands) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__card es__card--brand';
      btn.dataset.pick = 'brand';
      btn.dataset.value = b.handle;
      btn.dataset.label = b.label;
      btn.innerHTML = `${imgHtml(b.image, b.label)}<span class="es__card-label">${b.label}</span>`;
      grid.appendChild(btn);
    }
  }

  function renderModelGrid() {
    const b = findBrand(state.brand);
    const grid = root.querySelector('[data-grid="model"]');
    if (!b || !grid) return;
    grid.innerHTML = '';
    for (const m of b.models) {
      const btn = document.createElement('button');
      const destination = (!m.generations || !m.generations.length)
        ? resolveDestination(state.brand, m.handle, null)
        : null;
      btn.type = 'button';
      btn.className = 'es__card es__card--model';
      btn.dataset.pick = 'model';
      btn.dataset.value = m.handle;
      btn.dataset.label = m.label;
      btn.innerHTML = `${reviewPillHtml(reviewStatusForDestination(destination))}${imgHtml(m.image, m.label)}<span class="es__card-label">${m.label}</span>`;
      grid.appendChild(btn);
    }
  }

  function renderGenerationGrid() {
    const m = findModel(state.brand, state.model);
    const grid = root.querySelector('[data-grid="generation"]');
    if (!m || !grid) return;
    grid.innerHTML = '';
    for (const g of (m.generations || [])) {
      const btn = document.createElement('button');
      const destination = resolveDestination(state.brand, state.model, g.handle);
      btn.type = 'button';
      btn.className = 'es__card es__card--gen';
      btn.dataset.pick = 'generation';
      btn.dataset.value = g.handle;
      btn.dataset.label = g.label;
      btn.innerHTML = `${reviewPillHtml(reviewStatusForDestination(destination))}${imgHtml(g.image, g.label)}<span class="es__card-label">${g.label}</span>`;
      grid.appendChild(btn);
    }
  }

  function renderClassicVersionGrid() {
    const familyId = state.classicFamily;
    const grid = root.querySelector('[data-grid="classic-version"]');
    const label = root.querySelector('[data-classic-family-label]');
    if (!grid) return;
    grid.innerHTML = '';

    const fam = ALL_FAMILIES[familyId];
    if (!fam) return;

    if (label) label.textContent = fam.label;

    fam.versions.forEach((version) => {
      const btn = document.createElement('button');
      const badges = (version.badges || [version.badge]).filter(Boolean);
      btn.type = 'button';
      btn.className = 'es__card es__classic-version-card';
      btn.dataset.pick = 'classic-version';
      btn.dataset.value = version.id;
      btn.dataset.label = version.label;
      if (version.pseCar) btn.dataset.pseCar = version.pseCar;
      btn.innerHTML = `
        ${reviewPillHtml(reviewForCar(version.id).status)}
        <span class="es__classic-version-media${badges.length > 1 ? ' es__classic-version-media--multi' : ''}">${badges.map((badge) => `<img src="${badge}" alt="" loading="lazy">`).join('')}</span>
        <span class="es__classic-version-label"><strong>${version.label}</strong><small>${version.meta || ''}</small><i aria-hidden="true">→</i></span>`;
      grid.appendChild(btn);
    });
  }

  // === Porsche classiques & schémas undercarriage ===
  const classicProductCache = new Map();

  function classicElements() {
    return {
      heading: root.querySelector('[data-classic-heading]'),
      description: root.querySelector('[data-classic-description]'),
      architecture: root.querySelector('[data-classic-architecture]'),
      stage: root.querySelector('.es__classic-stage'),
      diagramImg: root.querySelector('[data-classic-diagram-img]'),
      diagrams: root.querySelectorAll('[data-classic-diagram]'),
      zones: root.querySelector('[data-classic-zones]'),
      legend: root.querySelector('[data-classic-legend]'),
      caption: root.querySelector('[data-classic-caption]'),
      accessories: root.querySelector('[data-classic-accessories]'),
      accessoriesGrid: root.querySelector('[data-classic-accessories-grid]'),
      results: root.querySelector('[data-classic-results]'),
      resultsTitle: root.querySelector('[data-classic-results-title]'),
      resultsDescription: root.querySelector('[data-classic-results-description]'),
      filters: root.querySelector('[data-classic-filters]'),
      count: root.querySelector('[data-classic-count]'),
      products: root.querySelector('[data-classic-products]')
    };
  }

  function setClassicHot(zoneId, active) {
    root.querySelectorAll(`[data-classic-zone="${zoneId}"]`).forEach((item) => {
      item.classList.toggle('is-hot', active);
    });
  }

  function markEditableZone(button) {
    if (!button) return;
    state.zoneSelection = {
      zoneId: button.dataset.classicZone,
      rectIndex: Number(button.dataset.rectIndex)
    };
    root.querySelectorAll('.es__classic-zone').forEach((item) => {
      item.classList.toggle('is-edit-selected', item === button);
    });
    syncZoneEditorControls();
  }

  function renderClassicZoneButtons(car, container) {
    if (!car || !container) return;
    container.innerHTML = '';
    (car.zones || []).forEach((zone) => {
      (zone.rects || []).forEach((rect, rectIndex) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'es__classic-zone';
        button.dataset.classicZone = zone.id;
        button.dataset.rectIndex = String(rectIndex);
        button.setAttribute('aria-label', zone.n);
        applyZoneRect(button, rect);
        if (state.zoneSelection && state.zoneSelection.zoneId === zone.id && state.zoneSelection.rectIndex === rectIndex) {
          button.classList.add('is-edit-selected');
        }
        button.addEventListener('mouseenter', () => setClassicHot(zone.id, true));
        button.addEventListener('mouseleave', () => setClassicHot(zone.id, false));
        button.addEventListener('focus', () => setClassicHot(zone.id, true));
        button.addEventListener('blur', () => setClassicHot(zone.id, false));
        button.innerHTML = ['nw', 'ne', 'sw', 'se']
          .map((handle) => `<span class="es__zone-handle es__zone-handle--${handle}" data-zone-handle="${handle}" aria-hidden="true"></span>`)
          .join('');
        button.addEventListener('click', (event) => {
          if (state.zoneEditing) {
            event.preventDefault();
            markEditableZone(button);
            return;
          }
          selectClassicZone(zone);
        });
        container.appendChild(button);
      });
    });
  }

  function renderClassicCar() {
    const car = CLASSIC.cars[state.classicCar];
    const els = classicElements();
    if (!car || !els.zones || !els.legend) return;
    setZoneEditing(false);
    state.zoneDirty = false;

    if (els.heading) els.heading.textContent = car.name;
    if (els.description) els.description.textContent = car.description;
    if (els.architecture) {
      const status = car.isProductionReference
        ? t('référence production', 'production reference')
        : t('zones en test', 'test zones');
      els.architecture.textContent = `${car.architecture} · ${status}`;
    }
    if (els.caption) {
      els.caption.textContent = car.isProductionReference
        ? car.caption
        : t('Prototype : dessin validé, placement des zones encore en contrôle sur le thème Dev.', 'Prototype: validated drawing, zone placement still under review on the Dev theme.');
    }
    renderReviewPanel(state.classicCar);

    // Display undercarriage diagram
    let imgSrc = car.image;
    if (!imgSrc && car.drawingAsset) {
      imgSrc = resolveDrawingUrl(car.drawingAsset);
    }
    const legacyDiagramId = state.classicCar.indexOf('type-g-') === 0 ? 'type-g' : state.classicCar;
    const legacyDiagram = root.querySelector(`[data-classic-diagram="${legacyDiagramId}"]`);
    if (!imgSrc && legacyDiagram) {
      imgSrc = legacyDiagram.src;
    }

    const applyDiagramRatio = () => {
      if (els.stage && els.diagramImg && els.diagramImg.naturalWidth && els.diagramImg.naturalHeight) {
        const ratio = els.diagramImg.naturalWidth / els.diagramImg.naturalHeight;
        els.stage.style.setProperty('--diagram-ratio', ratio);
      }
    };

    if (els.diagramImg) {
      if (imgSrc) {
        els.diagramImg.src = imgSrc;
        els.diagramImg.alt = car.alt || car.name;
        els.diagramImg.hidden = false;
        if (els.diagramImg.complete && els.diagramImg.naturalWidth) {
          applyDiagramRatio();
        } else {
          els.diagramImg.onload = applyDiagramRatio;
        }
      } else {
        els.diagramImg.hidden = true;
      }
    }
    // Hide legacy hardcoded diagrams
    els.diagrams.forEach((image) => { image.hidden = true; });

    els.legend.innerHTML = '';
    closeClassicResults();

    renderClassicZoneButtons(car, els.zones);

    (car.zones || []).forEach((zone) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'es__classic-legend-card';
      card.dataset.classicZone = zone.id;
      card.innerHTML = `<span><strong>${zone.n}</strong><small>${zone.d || ''}</small></span><i aria-hidden="true">›</i>`;
      card.addEventListener('mouseenter', () => setClassicHot(zone.id, true));
      card.addEventListener('mouseleave', () => setClassicHot(zone.id, false));
      card.addEventListener('focus', () => setClassicHot(zone.id, true));
      card.addEventListener('blur', () => setClassicHot(zone.id, false));
      card.addEventListener('click', () => selectClassicZone(zone));
      els.legend.appendChild(card);
    });

    // Render complementary accessories section if vehicle has accessories
    if (els.accessories && els.accessoriesGrid) {
      els.accessoriesGrid.innerHTML = '';
      const accessories = car.accessories || [];
      if (accessories.length > 0) {
        els.accessories.hidden = false;
        accessories.forEach((acc) => {
          const card = document.createElement('a');
          card.className = 'es__accessory-card';
          card.href = `${localePrefix}/products/${acc.handle}`;

          const categoryLabels = {
            filter: t('Filtration sport', 'Sport air filter'),
            switch: t('Commande de valves', 'Valve control'),
            pse: t('Module PSE', 'PSE module'),
            sensor: t('Capteur', 'Sensor'),
            hardware: t('Fixation & quincaillerie', 'Hardware & mounting'),
            bracket: t('Support PSE', 'PSE bracket'),
            service: t('Service atelier', 'Workshop service')
          };
          const badgeLabel = categoryLabels[acc.category] || t('Accessoire', 'Accessory');

          card.innerHTML = `
            <span class="es__accessory-media" data-acc-media="${acc.handle}"><i>SCART</i></span>
            <span class="es__accessory-badge">${badgeLabel}</span>
            <strong>${acc.title}</strong>
            <p>${acc.description || ''}</p>
            <b data-acc-price="${acc.handle}"></b>
          `;

          fetchClassicProduct(acc.handle).then((prod) => {
            const mediaEl = card.querySelector(`[data-acc-media="${acc.handle}"]`);
            const priceEl = card.querySelector(`[data-acc-price="${acc.handle}"]`);
            if (mediaEl && prod.featured_image) {
              mediaEl.innerHTML = `<img src="${prod.featured_image}" alt="${prod.title}" loading="lazy">`;
            }
            if (priceEl && prod.price) {
              priceEl.textContent = formatClassicMoney(prod.price);
            }
          }).catch(() => {});

          card.addEventListener('click', () => trackEvent('configurator_accessory_click', {
            car: state.classicCar,
            accessory_handle: acc.handle
          }));

          els.accessoriesGrid.appendChild(card);
        });
      } else {
        els.accessories.hidden = true;
      }
    }

    setClassicQuery(state.classicCar);
    updateBreadcrumb();
  }

  function renderReviewPanel(carId) {
    const panel = root.querySelector('[data-review-panel]');
    if (!panel) return;
    const review = reviewForCar(carId);
    const label = panel.querySelector('[data-review-label]');
    const detail = panel.querySelector('[data-review-detail]');
    const edit = panel.querySelector('[data-review-edit-zones]');
    const validate = panel.querySelector('[data-review-validate]');
    const promote = panel.querySelector('[data-review-promote]');
    const reject = panel.querySelector('[data-review-reject]');
    const reason = panel.querySelector('[data-review-reason]');
    panel.hidden = false;
    panel.dataset.reviewStatus = review.status || 'pending';
    if (label) label.textContent = reviewLabel(review.status);
    if (detail) {
      if (review.status === 'rejected') {
        detail.textContent = (review.reason || t('Une correction a été demandée.', 'A correction was requested.'));
      } else if (review.status === 'validated') {
        detail.textContent = review.published
          ? t('Ce parcours est en ligne sur le site.', 'This journey is live on the website.')
          : t('Zones contrôlées et enregistrées pour le test par Brieuc.', 'Zones reviewed and saved to the test journey by Brieuc.');
      } else {
        detail.textContent = t('Placement des zones en attente de contrôle.', 'Zone placement is pending review.');
      }
    }
    if (edit) {
      edit.disabled = Boolean(review.locked);
      edit.setAttribute('aria-pressed', state.zoneEditing ? 'true' : 'false');
      edit.textContent = state.zoneEditing
        ? t('Terminer le réglage', 'Finish adjusting')
        : t('Modifier les zones', 'Adjust zones');
    }
    if (validate) validate.disabled = Boolean(review.locked);
    if (promote) {
      promote.disabled = review.status !== 'validated' || Boolean(review.published);
      promote.textContent = review.published
        ? t('Déjà en live', 'Already live')
        : t('Envoyer en live sur le site', 'Send live to the website');
    }
    if (reject) reject.disabled = Boolean(review.locked);
    if (reason && document.activeElement !== reason) reason.value = review.status === 'rejected' ? review.reason || '' : '';
  }

  function reviewFamilyZones(carId) {
    const familyId = FAMILY_BY_CAR[carId] || carId;
    const family = CONFIG_DATA.familyMap && CONFIG_DATA.familyMap[familyId];
    const familyVehicleIds = family && family.vehicleIds ? family.vehicleIds : [carId];
    const vehicleIds = [carId].concat(familyVehicleIds.filter((vehicleId) => vehicleId !== carId));
    const zones = {};
    vehicleIds.forEach((vehicleId) => {
      const catalogId = CLASSIC.cars[vehicleId] ? vehicleId : (CANONICAL_ALIASES[vehicleId] || vehicleId);
      const car = CLASSIC.cars[catalogId];
      if (!car) return;
      (car.zones || []).forEach((zone) => {
        if (!zones[zone.id]) zones[zone.id] = (zone.rects || []).map((rect) => rect.map(Number));
      });
    });
    return { familyId, zones };
  }

  function postReview(payload, path) {
    return fetch(root.dataset.reviewApi + (path || '/zones/review'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then((response) => response.json().catch(() => ({})).then((body) => {
      if (!response.ok || !body.ok) throw new Error(body.error || t('Enregistrement impossible.', 'Unable to save.'));
      return body;
    }));
  }

  function applyReviewDecision(result) {
    REVIEW_STATE.families[result.family] = result.decision;
    (result.cars || []).forEach((carId) => { REVIEW_STATE.cars[carId] = result.decision; });
    state.zoneDirty = false;
    setZoneEditing(false);
    renderReviewPanel(state.classicCar);
  }

  function clampZoneValue(value, min, max) {
    return Math.max(min, Math.min(max, Math.round(value * 10) / 10));
  }

  function activeZoneRect(button) {
    const car = CLASSIC.cars[state.classicCar];
    if (!car) return null;
    const zone = (car.zones || []).find((item) => item.id === button.dataset.classicZone);
    if (!zone) return null;
    const rect = zone.rects && zone.rects[Number(button.dataset.rectIndex)];
    return Array.isArray(rect) ? rect : null;
  }

  function applyZoneRect(button, rect) {
    button.style.setProperty('--left', `${rect[0]}%`);
    button.style.setProperty('--top', `${rect[1]}%`);
    button.style.setProperty('--width', `${rect[2]}%`);
    button.style.setProperty('--height', `${rect[3]}%`);
  }

  function setZoneEditing(active) {
    state.zoneEditing = Boolean(active);
    state.zoneDrag = null;
    state.zoneSelection = null;
    root.classList.toggle('is-zone-editing', state.zoneEditing);
    const edit = root.querySelector('[data-review-edit-zones]');
    const help = root.querySelector('[data-review-zone-help]');
    if (edit) {
      edit.setAttribute('aria-pressed', state.zoneEditing ? 'true' : 'false');
      edit.textContent = state.zoneEditing
        ? t('Terminer le réglage', 'Finish adjusting')
        : t('Modifier les zones', 'Adjust zones');
    }
    if (help) help.hidden = !state.zoneEditing;
    syncZoneEditorControls();
    if (state.zoneEditing) closeClassicResults();
  }

  function syncZoneEditorControls() {
    const car = CLASSIC.cars[state.classicCar];
    const select = root.querySelector('[data-review-zone-target]');
    const remove = root.querySelector('[data-review-zone-delete]');
    const status = root.querySelector('[data-review-zone-selection]');
    if (!car) return;
    if (select) {
      const previous = select.value;
      select.innerHTML = '';
      (car.zones || []).forEach((zone) => {
        const option = document.createElement('option');
        option.value = zone.id;
        option.textContent = zone.n;
        select.appendChild(option);
      });
      if ((car.zones || []).some((zone) => zone.id === previous)) select.value = previous;
    }
    const selection = state.zoneSelection;
    const zone = selection && (car.zones || []).find((item) => item.id === selection.zoneId);
    const validSelection = Boolean(zone && zone.rects && zone.rects[selection.rectIndex]);
    if (remove) remove.disabled = !validSelection;
    if (status) {
      status.textContent = validSelection
        ? `${t('Zone sélectionnée', 'Selected zone')} : ${zone.n} (${selection.rectIndex + 1}/${zone.rects.length})`
        : t('Sélectionnez une zone sur le dessin pour pouvoir la supprimer.', 'Select a zone on the diagram to delete it.');
    }
  }

  function wireInlineZoneEditor() {
    const zones = root.querySelector('[data-classic-zones]');
    const edit = root.querySelector('[data-review-edit-zones]');
    if (!zones || !edit) return;

    edit.addEventListener('click', () => {
      const review = reviewForCar(state.classicCar);
      if (review.locked) return;
      setZoneEditing(!state.zoneEditing);
    });

    zones.addEventListener('pointerdown', (event) => {
      if (!state.zoneEditing) return;
      const button = event.target.closest('.es__classic-zone');
      if (!button) return;
      markEditableZone(button);
      const rect = activeZoneRect(button);
      const stage = classicElements().stage;
      if (!rect || !stage) return;
      event.preventDefault();
      const handle = event.target.dataset.zoneHandle || 'move';
      state.zoneDrag = {
        pointerId: event.pointerId,
        button,
        handle,
        startX: event.clientX,
        startY: event.clientY,
        startRect: rect.slice(),
        stageRect: stage.getBoundingClientRect()
      };
      button.setPointerCapture(event.pointerId);
    });

    zones.addEventListener('pointermove', (event) => {
      const drag = state.zoneDrag;
      if (!drag || drag.pointerId !== event.pointerId) return;
      const rect = activeZoneRect(drag.button);
      if (!rect) return;
      const dx = (event.clientX - drag.startX) / drag.stageRect.width * 100;
      const dy = (event.clientY - drag.startY) / drag.stageRect.height * 100;
      const start = drag.startRect;
      if (drag.handle === 'move') {
        rect[0] = clampZoneValue(start[0] + dx, 0, 100 - start[2]);
        rect[1] = clampZoneValue(start[1] + dy, 0, 100 - start[3]);
      } else {
        const right = start[0] + start[2];
        const bottom = start[1] + start[3];
        if (drag.handle.includes('w')) {
          rect[0] = clampZoneValue(start[0] + dx, 0, right - 0.5);
          rect[2] = clampZoneValue(right - rect[0], 0.5, 100 - rect[0]);
        }
        if (drag.handle.includes('e')) rect[2] = clampZoneValue(start[2] + dx, 0.5, 100 - start[0]);
        if (drag.handle.includes('n')) {
          rect[1] = clampZoneValue(start[1] + dy, 0, bottom - 0.5);
          rect[3] = clampZoneValue(bottom - rect[1], 0.5, 100 - rect[1]);
        }
        if (drag.handle.includes('s')) rect[3] = clampZoneValue(start[3] + dy, 0.5, 100 - start[1]);
      }
      state.zoneDirty = true;
      applyZoneRect(drag.button, rect);
    });

    const finishDrag = (event) => {
      if (!state.zoneDrag || state.zoneDrag.pointerId !== event.pointerId) return;
      state.zoneDrag = null;
    };
    zones.addEventListener('pointerup', finishDrag);
    zones.addEventListener('pointercancel', finishDrag);

    const add = root.querySelector('[data-review-zone-add]');
    const remove = root.querySelector('[data-review-zone-delete]');
    const target = root.querySelector('[data-review-zone-target]');
    if (add && target) {
      add.addEventListener('click', () => {
        const car = CLASSIC.cars[state.classicCar];
        const zone = car && (car.zones || []).find((item) => item.id === target.value);
        if (!zone) return;
        if (!Array.isArray(zone.rects)) zone.rects = [];
        if (zone.rects.length >= 4) {
          window.alert(t('Quatre zones maximum peuvent être raccordées à cette pièce.', 'A maximum of four zones can be connected to this part.'));
          return;
        }
        const offset = Math.min(zone.rects.length * 3, 12);
        zone.rects.push([40 + offset, 40 + offset, 20, 20]);
        state.zoneDirty = true;
        state.zoneSelection = { zoneId: zone.id, rectIndex: zone.rects.length - 1 };
        renderClassicZoneButtons(car, zones);
        syncZoneEditorControls();
      });
    }
    if (remove) {
      remove.addEventListener('click', () => {
        const car = CLASSIC.cars[state.classicCar];
        const selection = state.zoneSelection;
        const zone = selection && car && (car.zones || []).find((item) => item.id === selection.zoneId);
        if (!zone || !zone.rects || !zone.rects[selection.rectIndex]) return;
        zone.rects.splice(selection.rectIndex, 1);
        state.zoneDirty = true;
        state.zoneSelection = null;
        renderClassicZoneButtons(car, zones);
        syncZoneEditorControls();
      });
    }
  }

  function setReviewBusy(button, busy, busyLabel) {
    if (!button) return;
    if (busy) {
      button.dataset.label = button.textContent;
      button.textContent = busyLabel;
      button.disabled = true;
    } else {
      button.textContent = button.dataset.label || button.textContent;
      button.disabled = false;
    }
  }

  function wireReviewPanel() {
    const panel = root.querySelector('[data-review-panel]');
    if (!panel) return;
    const validate = panel.querySelector('[data-review-validate]');
    const promote = panel.querySelector('[data-review-promote]');
    const reject = panel.querySelector('[data-review-reject]');
    const form = panel.querySelector('[data-review-form]');
    const reason = panel.querySelector('[data-review-reason]');
    const cancel = panel.querySelector('[data-review-cancel]');

    validate.addEventListener('click', () => {
      const current = reviewForCar(state.classicCar);
      if (current.locked) return;
      const payload = reviewFamilyZones(state.classicCar);
      if (!window.confirm(t('Enregistrer cette validation et ces zones uniquement dans le configurateur de test ?', 'Save this validation and its zones only to the test journey?'))) return;
      setReviewBusy(validate, true, t('Enregistrement…', 'Saving…'));
      postReview({
        family: payload.familyId,
        zones: payload.zones,
        status: 'validated',
        reviewer: 'Brieuc'
      }).then(applyReviewDecision).catch((error) => {
        window.alert(error.message);
      }).finally(() => {
        setReviewBusy(validate, false);
        renderReviewPanel(state.classicCar);
      });
    });

    promote.addEventListener('click', () => {
      const current = reviewForCar(state.classicCar);
      if (current.status !== 'validated' || current.published) return;
      const payload = reviewFamilyZones(state.classicCar);
      const car = CLASSIC.cars[state.classicCar];
      if (!window.confirm(t(
        `Envoyer maintenant ${car ? car.name : 'ce parcours'} en live sur scart.com ? Il deviendra visible par les clients.`,
        `Send ${car ? car.name : 'this journey'} live on scart.com now? It will become visible to customers.`
      ))) return;
      setReviewBusy(promote, true, t('Mise en ligne…', 'Going live…'));
      postReview({
        family: payload.familyId,
        reviewer: 'Brieuc'
      }, '/zones/promote').then(applyReviewDecision).catch((error) => {
        window.alert(error.message);
      }).finally(() => {
        setReviewBusy(promote, false);
        renderReviewPanel(state.classicCar);
      });
    });

    reject.addEventListener('click', () => {
      form.hidden = false;
      reason.focus();
    });
    cancel.addEventListener('click', () => { form.hidden = true; });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const value = reason.value.trim();
      if (!value) {
        reason.focus();
        return;
      }
      const submit = form.querySelector('[type="submit"]');
      const payload = reviewFamilyZones(state.classicCar);
      setReviewBusy(submit, true, t('Enregistrement…', 'Saving…'));
      postReview({
        family: payload.familyId,
        status: 'rejected',
        reason: value,
        reviewer: 'Brieuc'
      }).then((result) => {
        applyReviewDecision(result);
        form.hidden = true;
      }).catch((error) => {
        window.alert(error.message);
      }).finally(() => setReviewBusy(submit, false));
    });
  }

  function normalizeClassicProduct(item) {
    return typeof item === 'string' ? { h: item, f: [] } : item;
  }

  function fetchClassicProduct(handle) {
    if (classicProductCache.has(handle)) return classicProductCache.get(handle);
    const promise = fetch(`${localePrefix}/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error(`Product ${handle}: ${response.status}`);
      return response.json();
    });
    classicProductCache.set(handle, promise);
    return promise;
  }

  function formatClassicMoney(cents) {
    const amount = Number(cents || 0) / 100;
    const locale = document.documentElement.lang || (isFr ? 'fr-FR' : 'en-GB');
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active : 'EUR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return `${amount.toFixed(0)} ${currency}`;
    }
  }

  function classicProductImage(product) {
    return product.featured_image || (product.images && product.images[0]) || '';
  }

  function createClassicProductCard(entry, choice) {
    const product = entry.product;
    const link = document.createElement('a');
    const image = classicProductImage(product);
    link.className = choice ? 'es__classic-choice es__card' : 'es__classic-product';
    link.href = `${localePrefix}/products/${entry.config.h}`;
    if (!product.available) link.classList.add('is-unavailable');
    if (choice) {
      const rangeLabels = {
        standard: t('Standard', 'Standard'),
        sport: 'Sport',
        racing: 'Racing'
      };
      const choiceLabel = entry.config.l || rangeLabels[entry.config.r] || product.title;
      link.setAttribute('aria-label', `${choiceLabel} — ${product.title} — ${formatClassicMoney(product.price)}`);
      link.innerHTML = `
        <span class="es__classic-choice-media">${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}</span>
        <strong>${choiceLabel}</strong>
        <b>${product.price ? formatClassicMoney(product.price) : ''}</b>`;
    } else {
      link.innerHTML = `
        <span class="es__classic-product-media">${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : '<i>SCART</i>'}</span>
        <span class="es__classic-product-copy"><strong>${entry.config.l || product.title}</strong><b>${product.price ? formatClassicMoney(product.price) : ''}</b>${product.available ? '' : `<small>${t('Indisponible','Unavailable')}</small>`}</span>`;
    }
    link.addEventListener('click', () => trackEvent('configurator_product_click', {
      car: state.classicCar,
      zone: state.classicZone ? state.classicZone.id : '',
      product_handle: entry.config.h
    }));
    return link;
  }

  function appendClassicScale(host, labels) {
    if (!labels || labels.length < 2) return;
    const scale = document.createElement('p');
    scale.className = 'es__classic-scale';
    scale.setAttribute('aria-hidden', 'true');
    labels.forEach((label, index) => {
      const span = document.createElement('span');
      span.textContent = label;
      scale.appendChild(span);
      if (index < labels.length - 1) scale.appendChild(document.createElement('i'));
    });
    host.appendChild(scale);
  }

  function appendClassicProductGrid(host, entries, label) {
    if (!entries.length) return;
    const section = document.createElement('section');
    const grid = document.createElement('div');
    section.className = 'es__classic-alternatives';
    grid.className = 'es__classic-product-grid';
    if (label) {
      const heading = document.createElement('h4');
      heading.textContent = label;
      section.appendChild(heading);
    }
    entries.forEach((entry) => grid.appendChild(createClassicProductCard(entry, false)));
    section.appendChild(grid);
    host.appendChild(section);
  }

  function renderClassicRange(entries, scaleLabels) {
    const els = classicElements();
    const journey = document.createElement('div');
    const heading = document.createElement('p');
    const row = document.createElement('div');
    journey.className = 'es__classic-journey';
    heading.className = 'es__classic-journey-head';
    heading.innerHTML = `<strong>${state.classicZone.journeyTitle || t('La même pièce, plusieurs versions','The same part, several versions')}</strong><span>${state.classicZone.journeyHint || ''}</span>`;
    row.className = 'es__classic-choice-row';
    row.style.setProperty('--choice-count', Math.min(entries.length, 3));
    entries.slice().sort((a, b) => Number(a.config.s || 0) - Number(b.config.s || 0))
      .forEach((entry) => row.appendChild(createClassicProductCard(entry, true)));
    journey.appendChild(heading);
    journey.appendChild(row);
    appendClassicScale(journey, scaleLabels || [t('Proche de l’origine','Close to stock'), t('Le plus radical','Most radical')]);
    if (state.classicZone && state.classicZone.warning) {
      const warning = document.createElement('p');
      warning.className = 'es__classic-warning';
      warning.textContent = state.classicZone.warning;
      journey.appendChild(warning);
    }
    els.products.appendChild(journey);
  }

  function classicMatchesFilter(entry) {
    if (!state.classicZone || !state.classicZone.filter) return true;
    if (!state.classicFilter) return false;
    return (entry.config.f || []).includes(state.classicFilter);
  }

  function appendClassicLoadWarning(host) {
    if (!state.classicZoneFailures.length) return;
    const warning = document.createElement('p');
    warning.className = 'es__product-load-warning';
    warning.textContent = t(
      'Certaines références non publiées sur la boutique ont été masquées.',
      'Some references that are not published on the storefront were hidden.'
    );
    host.appendChild(warning);
  }

  function renderClassicProducts() {
    const els = classicElements();
    els.products.innerHTML = '';
    if (state.classicZone && state.classicZone.filter && !state.classicFilter) {
      els.count.textContent = t('Choisissez une option pour voir les références.', 'Choose an option to see the products.');
      return;
    }
    const visible = (state.classicZoneProducts || []).filter((entry) => entry.product && classicMatchesFilter(entry));
    els.count.textContent = `${visible.length} ${visible.length === 1 ? t('produit','product') : t('produits','products')}`;
    if (!visible.length) {
      els.products.innerHTML = `<p class="es__empty">${t('Aucune référence disponible pour ce choix.','No product available for this selection.')}</p>`;
      appendClassicLoadWarning(els.products);
      return;
    }
    const sound = visible.filter((entry) => entry.config.g === 'sound');
    if (sound.length > 1) {
      renderClassicRange(sound, state.classicZone.scale || [t('Discret','Quiet'), t('Sonore','Loud')]);
      appendClassicProductGrid(els.products, visible.filter((entry) => entry.config.g === 'catalyst'), t('Avec catalyseur','With catalytic converter'));
      appendClassicProductGrid(els.products, visible.filter((entry) => entry.config.g === 'valve'), t('Avec valves','With valves'));
      appendClassicProductGrid(els.products, visible.filter((entry) => !entry.config.g), state.classicZone.otherLabel || '');
      appendClassicLoadWarning(els.products);
      return;
    }
    if (visible.length > 1 && visible.every((entry) => Boolean(entry.config.r))) {
      renderClassicRange(visible, state.classicZone.scale);
      appendClassicLoadWarning(els.products);
      return;
    }
    appendClassicProductGrid(els.products, visible, '');
    appendClassicLoadWarning(els.products);
  }

  function renderClassicFilter(zone) {
    const els = classicElements();
    els.filters.innerHTML = '';
    if (!zone.filter) return;
    const label = document.createElement('p');
    const options = document.createElement('div');
    label.className = 'es__classic-filter-label';
    label.textContent = zone.filter.label;
    options.className = 'es__classic-filter-options';
    zone.filter.options.forEach((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'es__classic-filter';
      button.textContent = option.l;
      button.addEventListener('click', () => {
        state.classicFilter = option.id;
        options.querySelectorAll('button').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        renderClassicProducts();
      });
      options.appendChild(button);
    });
    els.filters.appendChild(label);
    els.filters.appendChild(options);
  }

  function selectClassicZone(zone) {
    const els = classicElements();
    state.classicZone = zone;
    state.classicFilter = null;
    state.classicZoneProducts = [];
    state.classicZoneFailures = [];
    root.querySelectorAll('[data-classic-zone]').forEach((item) => {
      item.classList.toggle('is-selected', item.dataset.classicZone === zone.id);
    });
    els.resultsTitle.textContent = zone.n;
    els.resultsDescription.textContent = zone.d;
    els.results.hidden = false;
    els.count.textContent = zone.filter
      ? t('Choisissez une option pour voir les références.', 'Choose an option to see the products.')
      : t('Chargement…', 'Loading…');
    els.products.innerHTML = '';
    renderClassicFilter(zone);
    updateBreadcrumb();
    const configs = (zone.products || []).map(normalizeClassicProduct);
    Promise.all(configs.map((config) => fetchClassicProduct(config.h)
      .then((product) => ({ config, product }))
      .catch((error) => ({ config, error }))))
      .then((loaded) => {
        if (state.classicZone !== zone) return;
        state.classicZoneProducts = loaded.filter((entry) => entry.product);
        state.classicZoneFailures = loaded.filter((entry) => entry.error);
        renderClassicProducts();
        els.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    trackEvent('configurator_select', { step: 'piece', value: zone.id, car: state.classicCar });
  }

  function closeClassicResults() {
    const els = classicElements();
    state.classicZone = null;
    state.classicFilter = null;
    state.classicZoneProducts = [];
    state.classicZoneFailures = [];
    if (els.results) els.results.hidden = true;
    root.querySelectorAll('[data-classic-zone]').forEach((item) => item.classList.remove('is-selected', 'is-hot'));
    updateBreadcrumb();
  }

  const classicClose = root.querySelector('[data-classic-close]');
  if (classicClose) classicClose.addEventListener('click', closeClassicResults);

  // === Echoes & breadcrumb ===
  function updateEchoes() {
    const brand = findBrand(state.brand);
    const model = findModel(state.brand, state.model);
    root.querySelectorAll('[data-echo="brand"]').forEach(el => el.textContent = brand ? brand.label : '');
    root.querySelectorAll('[data-echo="model"]').forEach(el => el.textContent = model ? model.label : '');
  }

  function updateBreadcrumb() {
    const bc = root.querySelector('[data-bc]');
    if (!bc) return;
    const list = bc.querySelector('.es__bc-list');
    list.innerHTML = '';
    const steps = [];
    const brand = findBrand(state.brand);
    const model = findModel(state.brand, state.model);
    const gen = findGen(state.brand, state.model, state.generation);

    if (brand) steps.push({ key: 'brand', label: brand.label });
    if (model) steps.push({ key: 'model', label: model.label });
    if (gen) steps.push({ key: 'generation', label: gen.label });
    if (state.classicFamily && ALL_FAMILIES[state.classicFamily] && !gen) {
      steps.push({ key: 'family', label: ALL_FAMILIES[state.classicFamily].label });
    }
    if (state.pendingPseChoice) {
      steps.push({ key: 'classic-version', label: state.pendingPseChoice.label });
    }
    if (state.classicCar && CLASSIC.cars[state.classicCar]) {
      const carName = CLASSIC.cars[state.classicCar].name.replace('Porsche 911 ', '');
      steps.push({ key: 'classic-version', label: carName });
    }
    if (state.classicZone) {
      steps.push({ key: 'piece', label: state.classicZone.n });
    }

    if (!steps.length) { bc.hidden = true; return; }
    bc.hidden = false;
    steps.forEach((s, i) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__bc-chip';
      btn.textContent = s.label;
      btn.addEventListener('click', () => jumpBack(s.key));
      li.appendChild(btn);
      if (i < steps.length - 1) {
        const sep = document.createElement('span');
        sep.className = 'es__bc-sep';
        sep.textContent = '›';
        li.appendChild(sep);
      }
      list.appendChild(li);
    });
  }

  function jumpBack(key) {
    if (key === 'brand') {
      state.model = null;
      state.generation = null;
      state.classicFamily = null;
      state.classicCar = null;
      state.pendingPseChoice = null;
      state.classicZone = null;
      setClassicQuery('');
      renderModelGrid();
      transitionTo('model');
      return;
    }
    if (key === 'model') {
      const model = findModel(state.brand, state.model);
      const destination = model && !(model.generations || []).length
        ? resolveDestination(state.brand, state.model, null) : null;
      state.generation = null;
      state.classicFamily = destination && destination.family;
      state.classicCar = null;
      state.pendingPseChoice = null;
      state.classicZone = null;
      setClassicQuery('');
      if (state.classicFamily) {
        renderClassicVersionGrid();
        transitionTo('classic-version');
      } else if (model && model.generations && model.generations.length) {
        renderGenerationGrid();
        transitionTo('generation');
      } else {
        renderModelGrid();
        transitionTo('model');
      }
      return;
    }
    if (key === 'generation') {
      const destination = resolveDestination(state.brand, state.model, state.generation);
      state.classicFamily = destination && destination.family;
      state.classicCar = null;
      state.pendingPseChoice = null;
      state.classicZone = null;
      setClassicQuery('');
      if (state.classicFamily) {
        renderClassicVersionGrid();
        transitionTo('classic-version');
      } else {
        renderGenerationGrid();
        transitionTo('generation');
      }
      return;
    }
    if (key === 'family' || key === 'classic-version') {
      if (state.classicFamily) {
        state.classicCar = null;
        state.pendingPseChoice = null;
        state.classicZone = null;
        setClassicQuery('');
        renderClassicVersionGrid();
        transitionTo('classic-version');
        return;
      }
    }
    if (key === 'piece') {
      closeClassicResults();
      return;
    }
  }

  function restart() {
    trackEvent('configurator_restart', {
      from: { brand: state.brand, model: state.model, generation: state.generation, car: state.classicCar }
    });
    Object.assign(state, {
      brand: null, model: null, generation: null,
      classicFamily: null, classicCar: null, classicZone: null, classicFilter: null,
      pendingPseChoice: null, classicZoneProducts: [], classicZoneFailures: []
    });
    setClassicQuery('');
    transitionTo('brand');
    renderBrandGrid();
  }

  // === Click Handlers ===
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-pick]');
    if (!btn) return;
    const pick = btn.dataset.pick;
    const val = btn.dataset.value;

    if (pick === 'brand') {
      state.brand = val;
      state.model = null;
      state.generation = null;
      state.classicFamily = null;
      state.classicCar = null;
      state.pendingPseChoice = null;
      state.classicZone = null;
      trackEvent('configurator_select', { step: 'brand', value: val });
      const selectedBrand = findBrand(val);
      if (selectedBrand && selectedBrand.models.length === 1) {
        const onlyModel = selectedBrand.models[0];
        state.model = onlyModel.handle;
        trackEvent('configurator_select', { step: 'model', value: onlyModel.handle, automatic: true });
        if (!onlyModel.generations || onlyModel.generations.length === 0) {
          const direct = resolveDestination(val, onlyModel.handle, null);
          if (direct && direct.family) {
            state.classicFamily = direct.family;
            transitionTo('classic-version');
            renderClassicVersionGrid();
            return;
          }
          if (direct && direct.car) {
            state.classicCar = direct.car;
            transitionTo('piece');
            renderClassicCar();
            return;
          }
        }
      }
      transitionTo('model');
      renderModelGrid();
      return;
    }

    if (pick === 'model') {
      state.model = val;
      state.generation = null;
      state.classicFamily = null;
      state.classicCar = null;
      state.pendingPseChoice = null;
      state.classicZone = null;
      trackEvent('configurator_select', { step: 'model', value: val });
      const m = findModel(state.brand, val);

      if (m && m.generations && m.generations.length > 0) {
        transitionTo('generation');
        renderGenerationGrid();
        return;
      }

      // Model without generation screen: check destination
      const dest = resolveDestination(state.brand, val, null);
      if (dest && dest.family) {
        state.classicFamily = dest.family;
        transitionTo('classic-version');
        renderClassicVersionGrid();
        return;
      }
      if (dest && dest.car) {
        state.classicCar = dest.car;
        transitionTo('piece');
        renderClassicCar();
        return;
      }
      return;
    }

    if (pick === 'generation') {
      state.generation = val;
      state.classicFamily = null;
      state.classicCar = null;
      state.pendingPseChoice = null;
      state.classicZone = null;
      trackEvent('configurator_select', { step: 'generation', value: val });

      const dest = resolveDestination(state.brand, state.model, val);
      if (dest && dest.family) {
        state.classicFamily = dest.family;
        transitionTo('classic-version');
        renderClassicVersionGrid();
        return;
      }
      if (dest && dest.car) {
        state.classicCar = dest.car;
        transitionTo('piece');
        renderClassicCar();
        return;
      }
      return;
    }

    if (pick === 'classic-version') {
      if (btn.dataset.pseCar) {
        state.pendingPseChoice = {
          withoutPse: val,
          withPse: btn.dataset.pseCar,
          label: btn.dataset.label
        };
        state.classicZone = null;
        trackEvent('configurator_select', { step: 'classic-version', value: val });
        transitionTo('pse');
        return;
      }
      state.classicCar = val;
      state.pendingPseChoice = null;
      state.classicZone = null;
      trackEvent('configurator_select', { step: 'classic-version', value: val });
      transitionTo('piece');
      renderClassicCar();
      return;
    }

    if (pick === 'pse' && state.pendingPseChoice) {
      state.classicCar = val === 'oui'
        ? state.pendingPseChoice.withPse
        : state.pendingPseChoice.withoutPse;
      trackEvent('configurator_select', { step: 'factory-pse', value: val, car: state.classicCar });
      state.pendingPseChoice = null;
      state.classicZone = null;
      transitionTo('piece');
      renderClassicCar();
      return;
    }
  });

  // Global restart button handlers
  root.querySelectorAll('[data-action="restart"]').forEach((btn) => {
    btn.addEventListener('click', restart);
  });

  // === Deep linking & Initial load ===
  function handleInitialQuery() {
    const url = new URL(window.location.href);
    const carId = url.searchParams.get('car');
    const col = url.searchParams.get('collection');

    if (carId && CLASSIC.cars[carId]) {
      state.classicCar = carId;
      // Auto-detect brand/model/gen if possible
      const veh = (CONFIG_DATA.vehicles || []).find(v => v.id === carId);
      if (veh) {
        state.brand = findBrandHandleByName(veh.brand || 'Porsche');
        state.model = veh.modelId || veh.model;
        state.generation = veh.generationId;
      }
      transitionTo('piece');
      renderClassicCar();
      return;
    }

    if (col) {
      // Find matching vehicle or destination
      const dest = resolveDestination(null, col, col);
      if (dest && dest.car && CLASSIC.cars[dest.car]) {
        state.classicCar = dest.car;
        transitionTo('piece');
        renderClassicCar();
        return;
      }
      if (dest && dest.family) {
        state.classicFamily = dest.family;
        transitionTo('classic-version');
        renderClassicVersionGrid();
        return;
      }
    }

    // Default: start on Brand grid
    renderBrandGrid();
  }

  wireReviewPanel();
  wireInlineZoneEditor();
  handleInitialQuery();
})();
